import { render, staticRenderFns } from "./shirt.vue?vue&type=template&id=ab933110"
import script from "./shirt.vue?vue&type=script&lang=js"
export * from "./shirt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports